export default __webpack_public_path__ + "static/media/kyc.b241daac.png";